var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-confirm-dialog',{attrs:{"isShow":_vm.state.isShow,"isLoading":_vm.state.isLoading,"isAuth":_vm.dialog.auth,"title":_vm.dialog.title,"message":_vm.dialog.message,"button":_vm.dialog.button}})
}
var staticRenderFns = []

export { render, staticRenderFns }